import React from 'react';
import { Popover, Typography } from 'antd';
import styled from 'styled-components';
import { useTranslation } from '../../../../../i18n/useTranslation';

const ReadOnlyContainer = styled.div`
    height: 18px;
    border: 1px solid #ff9800;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ff9800;
    margin-left: 0px;
    margin-right: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 4px;
    padding-left: 4px;
`;

const ReadOnlyText = styled.div`
    padding-right: 2px;
    padding-left: 2px;
`;

const ReadOnlyTitle = styled(Typography.Text)`
    display: block;
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: bold;
`;

export const ReadOnlyPill = () => {
    const { t } = useTranslation();

    return (
        <Popover
            className="ml-1"
            overlayStyle={{ maxWidth: 240, zIndex: 1100 }}
            placement="right"
            content={
                <>
                    <ReadOnlyTitle>{t('Read Only')}</ReadOnlyTitle>
                    <Typography.Text type="secondary">
                        {t('This asset is marked as read only and cannot be modified.')}
                    </Typography.Text>
                </>
            }
        >
            <ReadOnlyContainer>
                <ReadOnlyText tabIndex={0} className="f-text-content">
                    {t('READ ONLY')}
                </ReadOnlyText>
            </ReadOnlyContainer>
        </Popover>
    );
};
